import styled from "styled-components";

export const Container = styled.div`
  margin: 4.88em 10%;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  @media (max-width: ${({ theme }) => theme.mobile.lg}) {
    /* justify-content: space-evenly; */
  }
  @media (max-width: ${({ theme }) => theme.mobile.md}) {
    margin: 2.25em 10%;
    display: block;
    justify-content: space-between;
  }
`;
export const InfoContact = styled.div`
  margin: 0 10%;
  color: #000;
  font-family: Poppins;
  font-size: 1rem;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  margin-top: -1em;
  @media (max-width: ${({ theme }) => theme.mobile.md}) {
    margin-top: 0em;
  }
`;
export const ContactUs = styled.span`
  cursor: pointer;
  color: #000;
  font-family: Poppins;
  font-size: 1rem;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  text-decoration-line: underline;
`;

export const ModalBackground = styled.span`
  background: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(4px);
  position: fixed;
  width: 100%;
  min-height: 100%;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 100;
`;
export const ModalCard = styled.span`
  width: 24.375rem;
  height: 33.25rem;
  background: #fff;
  border-radius: 0.625rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 2.5rem;
  position: relative;
  @media (max-width: ${({ theme }) => theme.mobile.md}) {
    width: 20.375rem;
  }
`;
